module.exports = __webpack_public_path__ + "static/media/JP_RCH_EYELASHES01.c68cd39e.jpg";